import React from 'react';
import { wave } from '../lib/waves';

/*
 * The stake. A dark band carrying one number, placed immediately above the
 * newsreel so the abstract figure is cashed out in named towns and lawsuits.
 *
 * The crest is a single wave that stays loud all the way across — this is the
 * problem side of the site, so it never resolves. The process timeline further
 * down is the same trace, damped to a flat line.
 */
const CREST = wave(1400, 30, 15, 9, 0, 1);

function StakeBand() {
  return (
    <section className="stake" id="problem">
      <svg
        className="stake-crest"
        viewBox="0 0 1400 60"
        preserveAspectRatio="none"
        aria-hidden="true"
        focusable="false"
      >
        <path d={CREST} fill="none" stroke="var(--accent)" strokeWidth="2" opacity="0.5" />
      </svg>

      <div className="wrap stake-inner">
        <p className="stake-number">$150B+</p>
        <div className="stake-copy">
          <p className="stake-lead">
            in datacenter projects blocked or delayed by community noise
            opposition since 2023.
          </p>
          <p className="stake-detail">
            Almost all of it comes down to one narrow band.{' '}
            <strong className="stake-emphasis">
              Generators, chillers and transformers put out 50&ndash;125&nbsp;Hz
              tones
            </strong>,{' '}
            long wavelengths that travel furthest, pass through walls, and are
            the ones neighbors describe as a hum they can feel. Stopping them
            with mass alone would take impractical thickness, the equipment
            still has to breathe, and the tone moves with fan speed, so a fix
            tuned once is off-target by the afternoon. So the noise stays, and
            projects get sued, capped, or voted down.
          </p>
        </div>
      </div>
    </section>
  );
}

export default StakeBand;
